import { createContext, useContext } from 'react';

import { SearchBonus } from '../../../../types/bonus';
import { SearchUser } from '../../types/user';

export const createSearchContext = () => ({
	bonuses: [] as SearchBonus[],
	bonusCount: 0,
	isFetching: false,
	hasAllRecords: false,
	hasAnyRecords: false,
	hasBonuses: false,
	hasUsers: false,
	query: '',
	recordCount: 0,
	userCount: 0,
	users: [] as SearchUser[],
});

export type SearchContextValue = ReturnType<typeof createSearchContext>;

export const SearchContext = createContext<SearchContextValue>(createSearchContext());

export const useSearchContext = () => useContext(SearchContext);
